import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import './NavbarCustomer.css';

import { language } from '../WEBContent/Language';

import {
    reqPOST,
    set_language,
    repo_site_assets_link, 
    repo_logo_link,
    passwordHash,
    content_language,
    translate,
    profile_access,
    reqGET
} from '../../../Utils';

import { usarToken } from "../../../UseToken";

import * as Hosts from "../../../Hosts";

import Swal from 'sweetalert2';

const Navbar = (props) => {

	const [, set_dados] = useState(null);
	const is_logged_in = useRef(null);
	const dados_config = useRef(null);
	const page_parent_location = useRef(null);
	const user_notification = useRef(null);

    const [user_access_level, set_user_access_level] = useState(0)

    const data_interface = {
        id: '',
        info: {},
        content: {
            childs: []
        }
    }

    const [navbar, set_navbar] = useState(data_interface);

    // const [user_profile, set_user_profile] = useState('');
    const [user_info, set_user_info] = useState('');
    const [pag_logo, set_pag_logo] = useState('');
    
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [lang_id, set_lang_id] = useState('1');

    const [enableFixedSideNavigationMenu, /*setEnableFixedSideNavigationMenu*/] = useState(true);

    const [page_location, set_page_location] = useState(useLocation().pathname.split('/').pop());

    const location = useLocation().pathname;

    const change_lang = (l) => {
        set_language(l)
        set_lang(l)
        window.location.reload()
    }

    useEffect(() => {

        function get_image_logo(el, type) {

            let result = ''

            // if(parseInt(lang_id) === 1) {

                if(el.content[0].logo !== undefined && el.content[0].logo !== null) {

                    if(type === 'url') {
                    result = el.content[0].logo.url
                    }

                }

            // }

            return result
        }

        set_dados(is_logged_in.current = false)

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                set_lang_id(el.id)
                }
            })
        }

        (async () => {

            let temp_token_info = await usarToken().getToken()
            let token_info = JSON.parse(temp_token_info)

            // console.log('Navbar.js token_info', token_info)
            // console.log('token_info.user_info', token_info.user_info)
            // console.log('token_info.user_info.companycode', token_info.user_info.companycode)

            // console.log('Navbar.js token_info', token_info)

            if(token_info !== undefined && token_info !== null && token_info.user_info !== undefined) {
                set_dados(is_logged_in.current = true)
                // set_user_profile(token_info.user_info.profile)
                set_user_info(token_info.user_info)

                // console.log('token_info.user_info.id', token_info.user_info.id)
                let not_aux = await reqGET(Hosts.SIMCore_API + '/web/client/notification/user/state/' + Hosts.companycode + '/' + token_info.user_info.id + '/0')
                set_dados(user_notification.current = not_aux.data)

                let profile_access_aux = profile_access.find(el => el.name.toLowerCase() === token_info.user_info.profile.toLowerCase())
                if(profile_access_aux !== undefined && profile_access_aux !== null) {
                    set_user_access_level(profile_access_aux.level)
                }

            }
            else {
                set_dados(is_logged_in.current = false)
            }

            if(page_location === 'all') {
                let aux = location.split('/all');
                set_page_location(aux[0].split('/').pop())
            }
            else if(location.includes('/user/')) {                
                set_dados(page_parent_location.current = 'user')
            }
            else if(location.includes('/relation/')) {                
                set_dados(page_parent_location.current = 'relation')
            }
            else if(location.includes('/support/')) {                
                set_dados(page_parent_location.current = 'support')
            }
            else if(location.includes('/information/')) {                
                set_dados(page_parent_location.current = 'information')
            }
            else {
                set_dados(page_parent_location.current = '')
            }
    
            set_navbar({ id: '', info: '', content: { childs: [] } })
    
            let getInfo = async () => {

                if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
                    set_dados(dados_config.current = props.dados_config)
                    set_pag_logo(get_image_logo(props.dados_config, 'url'))
                }
                else {
                    set_dados(dados_config.current = {})
                    set_pag_logo(repo_logo_link('logo.svg'))
                }
            
                if(is_logged_in.current) {
                    if(props.dados_navbar !== undefined && props.dados_navbar !== null && props.dados_navbar !== '') {
                        set_navbar(props.dados_navbar)
                    }
                }
            }
            await getInfo()
            setLoading(false)

        })()

    }, [location, page_location, lang])

    const do_login = async () => {

        const { value: formValues } = await Swal.fire({
            title: "",
            html: "" +
                "<div class='mb-4'>" +
                    "<img alt='' class='p-2' src=" + pag_logo + " style=\"width: 180px;\" />" +
                "</div>" +
                '<div class="form-group text-left">' +
                    "<label>" + language[lang].username + "</label>" +
                    '<input id="swal-input1" type="text" class="form-input w-100 form-control-lg rounded-0 border-0 bg-color-gray-light" />' +
                "</div>" +
                '<div class="form-group text-left position-relative">' +
                    "<label>" + language[lang].password + "</label>" +
                    '<input id="swal-input2" type="password" class="form-input w-100 form-control-lg rounded-0 border-0 bg-color-gray-light" />' +
                    '<i className="bi bi-eye-slash-fill position-absolite" style="font-size: 30px; right: 15px; bottom: 8px; width: 30px"></i>' +
                "</div>" +
            "",
            confirmButtonColor: "var(--primary)",
            confirmButtonText: "" + language[lang].login + "",
            focusConfirm: false,
            preConfirm: () => {
              return [
                document.getElementById("swal-input1").value,
                document.getElementById("swal-input2").value
              ];
            }
        });
        
        if (formValues) {

            let dados_envio = {
                companycode: Hosts.companycode,
                username: formValues[0],
                password: passwordHash(formValues[1])
            }

            reqPOST(Hosts.SIMCore_API + '/login', dados_envio)
                .then(objToken => {

                    if (objToken.token !== false && (profile_access.find(el => el.name.toLowerCase() === objToken.user_info.profile.toLowerCase()) !== undefined && profile_access.find(el => el.name.toLowerCase() === objToken.user_info.profile.toLowerCase()) !== null)) {
                        // console.log('objToken.user_info', objToken.user_info)

                        usarToken().saveToken(objToken, objToken.user_info)

                        window.location.reload();
                    }
                    else {

                        Swal.fire(language[lang].failed_login, language[lang].incorrect_login_data, 'warning')
                        localStorage.clear()

                    }
                })

        }

    }

    const do_logout = async () => {
        usarToken().logout()
    }

    return (
        isloading ?
          null
        :
            <>
                {
                <div className={"sticky-top bg-white"}>
                    <div className='container-fluid'>
                        {
                        is_logged_in.current ?
                            <div className="topbar">
                                <div className='container'>
                                    <div className='topbar-aligment'>
                                        <ul className="list-inline m-0">
                                            {
                                            parseInt(user_access_level) < 5 ? 
                                                (user_notification.current !== undefined && user_notification.current !== null && user_notification.current.length > 0 ?
                                                    <li>
                                                        <a href={Hosts.WEB_SITE_URI + 'list/notifications'} >
                                                            <i className="bi bi-bell me-3"></i>
                                                        </a>
                                                    </li>
                                                :
                                                    <li>
                                                        <a href={Hosts.WEB_SITE_URI + 'list/notifications'} >
                                                            <i className="bi bi-bell-slash me-3"></i>
                                                        </a>
                                                    </li>
                                                )
                                            :
                                                null
                                            }
                                            <li>
                                                {language[lang].welcome} &nbsp;&nbsp; <strong>{user_info?.name}</strong>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        :
                            null
                        }
                        <section id="navbar">
                            <nav className="navbar navbar-expand-lg bg-navbar py-0 px-0 nav-effect">
                                <div className="col-12">
                                    <div className="row">
                                        <div className="col-12 col-xl-10 mx-auto d-flex justify-content-center py-0">
                                            <a className="navbar-brand pl-2" href={Hosts.WEB_SITE_URI} alt={Hosts.webSiteTitle}>
                                                <img id="big-logo"
                                                    className="svg-logo img-fluid"
                                                    src={pag_logo}
                                                    alt={dados_config.current.content !== undefined && dados_config.current.content[0].title !== undefined ? translate(dados_config.current.content[0].title, lang) : Hosts.webSiteTitle}
                                                    title={dados_config.current.content !== undefined && dados_config.current.content[0].title !== undefined ? translate(dados_config.current.content[0].title, lang) : Hosts.webSiteTitle}
                                                />
                                            </a>
                                            <ul className="navbar-extra ml-auto">
                                                {
                                                is_logged_in.current ?
                                                    <li className="dropdown nav-item me-3 d-none" style={{ zIndex: '21' }}>
                                                        <a href={Hosts.WEB_BACKOFFICE_URI} className='d-none'>
                                                            <i className="bi bi-person-fill bi-2x"></i>
                                                        </a>
                                                        <a className="dropdown-toggle" href="/#" /*id="accountDropdown"*/ title={language[lang].my_account} role="button" data-bs-toggle="dropdown" aria-label={language[lang].my_account} aria-expanded="false">
                                                            <i className="bi bi-person-fill bi-2x"></i>
                                                        </a>
                                                        <div className="dropdown-menu" /*aria-labelledby="accountDropdown"*/>
                                                            <a href={Hosts.WEB_BACKOFFICE_URI + '/client_regist'} className='dropdown-item d-none' title={language[lang].my_account}>
                                                                <i className="bi bi-person-circle me-2"></i>
                                                                {language[lang].my_account}
                                                            </a>
                                                            <a href={Hosts.WEB_SITE_URI + 'user/profile'} className='dropdown-item' title={language[lang].my_account}>
                                                                <i className="bi bi-person-circle me-2"></i>
                                                                {language[lang].my_account}
                                                            </a>
                                                            <a href={Hosts.WEB_SITE_URI} className='dropdown-item' onClick={() => do_logout()} title={language[lang].logout}>
                                                                {language[lang].logout} <i className="bi bi-arrow-right-square me-2"></i>
                                                                
                                                            </a>
                                                        </div>
                                                    </li>
                                                :
                                                    <li className='my-account me-lg-3 d-none' style={{ zIndex: '21' }}>                                                    
                                                        <button type="button" className='button_no_border' onClick={() => do_login()}>
                                                            <i className="bi bi-person-lock bi-2x"></i>
                                                        </button>
                                                    </li>
                                                }
                                            </ul>
                                            <button className="navbar-toggler align-self-center" type="button" /*onClick={changeLogo}*/ data-bs-toggle="collapse" data-target="#sideNavigationMenu" aria-controls="sideNavigationMenu" aria-expanded="false" aria-label="Toggle navigation">
                                                {/*<span className="navbar-toggler-icon"></span>*/}
                                                <div className="animated-icon3">
                                                    <span></span>
                                                    <span></span>
                                                    <span></span>
                                                </div>
                                            </button>
                                        </div>
                                        {
                                        is_logged_in.current ?
                                            <div className="collapse navbar-collapse" id="sideNavigationMenu">

                                                <ul className="navbar-nav my-2">
                                                    <li className="nav-item d-block d-lg-none text-center mb-3">
                                                        <button className={"nav-link d-inline-block p-2 button_no_border " + (lang === 'pt' ? 'current_lang' : '')} onClick={() => change_lang('pt')}>PT</button>
                                                        &#124;
                                                        <button className={"nav-link d-inline-block p-2 button_no_border " + (lang === 'en' ? 'current_lang' : '')} onClick={() => change_lang('en')}>EN</button>
                                                        &#124;
                                                        <button className={"nav-link d-inline-block p-2 button_no_border " + (lang === 'es' ? 'current_lang' : '')} onClick={() => change_lang('es')}>ES</button>
                                                        &#124;
                                                        <button className={"nav-link d-inline-block p-2 button_no_border " + (lang === 'fr' ? 'current_lang' : '')} onClick={() => change_lang('fr')}>FR</button>
                                                    </li>
                                                    <li className="nav-item d-block d-lg-none text-center mb-3">
                                                        <a className="text-uppercase" href="faqs">
                                                            <img className="img-fluid" src={repo_site_assets_link("faqs.svg")} alt={"FAQs"} title={"FAQs"} />
                                                        </a>
                                                    </li>
                                                    {
                                                        props.mostrar_botao_voltar ?
                                                            <li className="nav-item" /* key={key} */ >
                                                                <a href={Hosts.WEB_SITE_URI} className={"nav-link"}>
                                                                    {/*<FontAwesomeIcon className="me-2" icon={faLongArrowAltLeft} />*/}
                                                                    {language[lang].back}
                                                                </a>
                                                            </li>
                                                        :
                                                            navbar.content.childs.map((v, key) => {

                                                                // console.log(v)

                                                                let link = ''
                                                                v.id_content !== '' ?
                                                                    link = (v.slug !== undefined && v.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id_content)
                                                                :
                                                                    link = (v.slug !== undefined && v.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.slug : (v.link.substr(0, 4) !== 'http' && v.link.substr(0, 3) !== 'www' ? Hosts.WEB_SITE_URI + v.link : (v.link.substr(0, 3) === 'www' ? 'http://' + v.link : v.link)))

                                                                let current_top_check = (v.slug !== undefined && v.slug !== '' ? v.slug : (v.id_content !== '' ? v.id_content : v.link));

                                                                if (location === '/' + v.link) {
                                                                    current_top_check = v.link
                                                                }

                                                                if (v.children !== undefined && v.children !== '' && v.children.length > 0) {

                                                                    return (
                                                                        <li className="nav-item dropdown" key={key}>
                                                                            <a className="nav-link dropdown-toggle" href="/#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                {v.title}
                                                                                <i className="bi bi-chevron-down ms-1" />
                                                                                {/*<FontAwesomeIcon icon={faAngleDown} fixedWidth />*/}
                                                                            </a>
                                                                            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                                                {
                                                                                    v.children.map((v2, key2) => {

                                                                                        //console.log(v2)

                                                                                        let link_content_dropdown_item = ''
                                                                                        v2.id_content !== '' ?
                                                                                            link_content_dropdown_item = (v2.slug !== undefined && v2.slug !== '' ? Hosts.WEB_SITE_URI + '' + v2.slug : Hosts.WEB_SITE_URI + 'pag/' + v2.id_content)
                                                                                            :
                                                                                            link_content_dropdown_item = (v2.slug !== undefined && v2.slug !== '' ? Hosts.WEB_SITE_URI + '' + v2.slug : (v2.link.substr(0, 4) !== 'http' && v2.link.substr(0, 3) !== 'www' ? Hosts.WEB_SITE_URI + v2.link : (v2.link.substr(0, 3) === 'www' ? 'http://' + v2.link : v2.link)))


                                                                                        //let link_content_dropdown_item = (v2.slug !== undefined && v2.slug !== '' ? Hosts.WEB_SITE_URI + '' + v2.slug : Hosts.WEB_SITE_URI + 'pag/' + v2.id_content);
                                                                                        let current_top_dropdown = (v2.slug !== undefined && v2.slug !== '' ? v2.slug : (v2.id_content !== '' ? v2.id_content : v2.link));

                                                                                        if (location === '/' + v2.link) {
                                                                                            current_top_dropdown = v2.link
                                                                                        }

                                                                                        return (
                                                                                            v2.link.substr(0, 4) !== 'http' && v2.link.substr(0, 3) !== 'www' ?
                                                                                                <a key={key2} href={link_content_dropdown_item} className={"dropdown-item " + ((page_location !== '' && page_location === current_top_dropdown) || (page_location !== '' && location === '/' + current_top_dropdown) ? 'current_top' : '')}  >
                                                                                                    {v2.title}
                                                                                                </a>
                                                                                                :
                                                                                                <a key={key2} href={link_content_dropdown_item} className={"dropdown-item " + ((page_location !== '' && page_location === current_top_dropdown) || (page_location !== '' && location === '/' + current_top_dropdown) ? 'current_top' : '')} target="_blank" rel="noreferrer" >
                                                                                                    {v2.title}
                                                                                                </a>
                                                                                        )
                                                                                    })
                                                                                }
                                                                            </div>
                                                                        </li>
                                                                    )
                                                                }
                                                                else {

                                                                    return (
                                                                        v.link.substr(0, 4) !== 'http' && v.link.substr(0, 3) !== 'www' ?
                                                                            <li className="nav-item" key={key} >
                                                                                <a href={link} className={"nav-link " + ((page_location !== '' && page_location === current_top_check) || (page_location !== '' && location === '/' + current_top_check) ? 'current_top' : '')} >
                                                                                    {v.title}
                                                                                </a>
                                                                            </li>
                                                                            :
                                                                            <li className="nav-item" key={key} >
                                                                                <a href={link} className={"nav-link " + ((page_location !== '' && page_location === current_top_check) || (page_location !== '' && location === '/' + current_top_check) ? 'current_top' : '')} target="_blank" rel="noreferrer" >
                                                                                    {v.title}
                                                                                </a>
                                                                            </li>

                                                                    )

                                                                }
                                                            })
                                                    }
                                                </ul>
                                                <ul className="navbar-nav social-media mt-3 text-center">
                                                    <li className="nav-item">
                                                        {
                                                            Hosts.fbLink !== '' ?
                                                                <a className="nav-link d-inline-block p-0 me-3" href={Hosts.fbLink} title="Facebook" alt="Facebook" target="_blank" rel="noreferrer">
                                                                    <i className="bi bi-facebook"></i>
                                                                    {/*<img src={repo_site_assets_link("facebook.svg")} title="Facebook" alt="Facebook" className="img-fluid"/>*/}
                                                                </a>
                                                            : null
                                                        }
                                                        {
                                                            Hosts.twitterLink !== '' ?
                                                                <a className="nav-link d-inline-block p-0 me-3" href={Hosts.twitterLink} title="Twitter X" alt="Twitter X" target="_blank" rel="noreferrer">
                                                                    <i className="bi bi-twitter-x"></i>
                                                                    {/*<img src={repo_site_assets_link("twitter.svg")} title="Twitter" alt="Twitter" className="img-fluid"/>*/}
                                                                </a>
                                                            : null
                                                        }
                                                        {
                                                            Hosts.instaLink !== '' ?
                                                                <a className="nav-link d-inline-block p-0" href={Hosts.instaLink} title="Instagram" alt="Instagram" target="_blank" rel="noreferrer">
                                                                    <i className="bi bi-instagram"></i>
                                                                    {/*<img src={repo_site_assets_link("instagram.svg")} title="Instagram" alt="Instagram" className="img-fluid"/>*/}
                                                                </a>
                                                            : null
                                                        }
                                                    </li>
                                                </ul>
                                                <div className="overlay d-none"></div>
                                            </div>
                                        :
                                            <div className="collapse navbar-collapse"></div>
                                        }
                                        {
                                        is_logged_in.current ?
                                            <div className='col-12 bg-primary collapse navbar-collapse' id="navbarNav">
                                                <ul className="navbar-nav mx-auto my-2">
                                                    {
                                                    navbar.content.childs.map((v, key) => {
                                                        let link = ''
                                                        v.id_content !== '' ?
                                                            link = (v.slug !== undefined && v.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.slug : Hosts.WEB_SITE_URI + 'pag/' + v.id_content)
                                                        :
                                                            link = (v.slug !== undefined && v.slug !== '' ? Hosts.WEB_SITE_URI + '' + v.slug : Hosts.WEB_SITE_URI + v.link)

                                                        let current_parent_link = '';
                                                        let current_parent_top_check = '';
                                                        let current_top_check = (v.slug !== undefined && v.slug !== '' ? v.slug : v.id_content);
                                                        if(current_top_check === '' && link.includes('/all')) {
                                                            let link_aux = link.split('/all')
                                                            let current_top_check_aux = link_aux[0].split('/')
                                                            current_top_check = current_top_check_aux.pop()
                                                            current_parent_top_check = current_top_check_aux.pop()
                                                        }
                                                        else if(current_top_check === '' && link.includes('/' + page_parent_location.current + '/')) {
                                                            let current_top_check_aux = link.split('/')
                                                            current_top_check = current_top_check_aux.pop()
                                                            current_parent_top_check = page_parent_location.current
                                                        }
                                                        
                                                        if(link.includes('/#')) {
                                                            let current_parent_link_aux = link.split('/#')
                                                            current_parent_link_aux = current_parent_link_aux[0].split('/')
                                                            current_parent_link = current_parent_link_aux.pop()
                                                        }

                                                        if (v.children !== undefined && v.children !== '' && v.children.length > 0) {
                                                            return (
                                                                <li key={key} className={"nav-item dropdown" + ' |' + page_parent_location.current + '| === |' + current_parent_top_check + '| '}>
                                                                    <a href="true" className={"nav-link dropdown-toggle" + (current_parent_top_check !== '' && page_parent_location.current === current_parent_top_check ? ' current_top show' : '')} id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                                        {v.title}
                                                                        <i className="bi bi-chevron-down ms-1" />
                                                                    </a>
                                                                    <div className={"dropdown-menu"} aria-labelledby="navbarDropdown">
                                                                        {
                                                                            v.children.map((v2, key2) => {
                                                                                let link_dropdown_item = ''
                                                                                let host_link = Hosts.WEB_SITE_URI

                                                                                if(v2.link === '') {
                                                                                    host_link += current_parent_link + '/'
                                                                                }

                                                                                v2.id_content !== '' ?
                                                                                    link_dropdown_item = (v2.slug !== undefined && v2.slug !== '' ? (host_link + '' + v2.slug) : (host_link + 'pag/' + v2.id_content))
                                                                                :
                                                                                    link_dropdown_item = (v2.slug !== undefined && v2.slug !== '' ? (host_link + '' + v2.slug) : (host_link + v2.link))
                                                                                
                                                                                let current_top_dropdown = (v2.slug !== undefined && v2.slug !== '' ? v2.slug : v2.id_content);
                                                                                if(current_top_dropdown === '') {
                                                                                    if(location === '/' + v2.link) {
                                                                                        current_top_dropdown = v2.link
                                                                                    }
                                                                                }

                                                                                return (
                                                                                    v2.link.substr(0, 4) !== 'http' ?
                                                                                        <a key={key2} href={link_dropdown_item} className={"dropdown-item " + ((page_location !== '' && page_location === current_top_dropdown) || (page_location !== '' && location === '/' + current_top_dropdown) ? 'current_top' : '')}  >
                                                                                            {lang === 'pt' || v2.language === undefined ? v2.title : (v2.language[lang_id] === undefined || v2.language[lang_id] === null || v2.language[lang_id].title === undefined || v2.language[lang_id].title === '' ? v2.title : v2.language[lang_id].title)}
                                                                                        </a>
                                                                                    :
                                                                                        <a key={key2} href={link_dropdown_item} className={"dropdown-item " + ((page_location !== '' && page_location === current_top_dropdown) || (page_location !== '' && location === '/' + current_top_dropdown) ? 'current_top' : '')} target="_blank" rel="noreferrer" >
                                                                                            {lang === 'pt' || v2.language === undefined ? v2.title : (v2.language[lang_id] === undefined || v2.language[lang_id] === null || v2.language[lang_id].title === undefined || v2.language[lang_id].title === '' ? v2.title : v2.language[lang_id].title)}
                                                                                        </a>
                                                                                )

                                                                            })
                                                                        }
                                                                    </div>
                                                                </li>
                                                            )
                                                        }
                                                        else {
                                                            return (
                                                                v.link.substr(0, 4) !== 'http' ?
                                                                    <li className="nav-item" key={key} >
                                                                        <a href={link} className={"nav-link " + ((page_location !== '' && page_location === current_top_check) || (current_parent_top_check !== '' && current_parent_top_check === current_top_check) ? 'current_top' : '')} >
                                                                            {v.title}
                                                                        </a>
                                                                    </li>
                                                                :
                                                                    <li className="nav-item" key={key} >
                                                                        <a href={link} className={"nav-link"} target="_blank" rel="noreferrer" >
                                                                            {v.title}
                                                                        </a>
                                                                    </li>
                                                                
                                                            )

                                                        }
                                                    })
                                                    }
                                                    {
                                                    parseInt(user_access_level) >= 5 ?
                                                        <li className="nav-item" >
                                                            <a href={Hosts.WEB_SITE_URI + 'list/clients'} className={"nav-link " + ' ' + ((page_location !== '' && page_location === 'clients') ? 'current_top' : '')} >
                                                                {language[lang].clients}
                                                            </a>
                                                        </li>
                                                    :
                                                        null
                                                    }
                                                    <li className="nav-item" >
                                                        <a href={Hosts.WEB_SITE_URI} className='nav-link' onClick={() => do_logout()} title={language[lang].logout}>
                                                            {language[lang].logout} <i className="bi bi-arrow-right-square ms-1"></i>
                                                            
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        :
                                            <div className='col-12 bg-primary collapse navbar-collapse p-1'></div>
                                        }
                                    </div>
                                </div>
                            </nav>
                        </section>
                    </div>
                </div >
                }
            </>



    )
};
export default Navbar;